module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_1585_storm_grey.9951ace6.jpg";